module.exports = __webpack_public_path__ + "img/portin.png";